{
    "metric_explainer__title": "Définition des métriques",
    "metric_explainer__erp_divergence": "Plato calcule au niveau de la ligne : chaque ligne de commande et de facture compte séparément. Une commande facturée en partie apporte ses lignes facturées au chiffre d'affaires. Les rapports qui ne comptent que les commandes entièrement facturées obtiennent un autre chiffre.",
    "metric_explainer__acl_note": "Les chiffres ne couvrent que les clients que vous avez le droit de voir.",
    "metric__billed__label": "Chiffre d'affaires",
    "metric__billed__definition": "Somme des lignes facturées, y compris celles des commandes facturées en partie. Les avoirs réduisent le chiffre d'affaires. Les lignes annulées ne comptent pas.",
    "metric__billed__date_basis": "Imputé à la date de facture.",
    "metric__billed_wo_credit_note__label": "Chiffre d'affaires (hors avoirs)",
    "metric__billed_wo_credit_note__definition": "Comme le chiffre d'affaires, mais sans les avoirs, donc plus élevé.",
    "metric__billed_wo_credit_note__date_basis": "Imputé à la date de facture.",
    "metric__not_billed__label": "Pas encore facturé",
    "metric__not_billed__definition": "Valeur des lignes de commande enregistrées mais pas encore facturées. Les lignes annulées et perdues ne comptent pas.",
    "metric__not_billed__date_basis": "Imputé à la date de saisie.",
    "metric__order_sum__label": "Prise de commandes",
    "metric__order_sum__definition": "Valeur de toutes les lignes de commande enregistrées. Les lignes annulées ne comptent pas.",
    "metric__order_sum__document_types": "Compte les types de document {{documentTypes}}.",
    "metric__order_sum__date_basis": "Imputé à la date de saisie.",
    "metric__gross_margin__label": "Marge brute",
    "metric__gross_margin__definition": "Somme de la marge brute des lignes qui composent {{base}}. L'ERP fournit la valeur par ligne.",
    "metric__gross_margin_percentage__label": "Marge brute %",
    "metric__gross_margin_percentage__definition": "Marge brute des mêmes lignes divisée par {{base}}.",
    "metric__units__label": "Quantité",
    "metric__units__definition": "Somme des quantités de ligne dans l'unité de l'ERP. Les unités différentes sont additionnées sans conversion.",
    "base__billed": "le chiffre d'affaires",
    "base__billed_wo_credit_note": "le chiffre d'affaires hors avoirs",
    "base__not_billed": "la valeur pas encore facturée",
    "base__order_sum": "la prise de commandes",
    "base__order_value": "la valeur de la commande",
    "base__quote_value": "la valeur du devis",
    "base__selected_figure": "le chiffre sélectionné",
    "document_type__ORDER": "Commande",
    "document_type__CREDITNOTE": "Avoir",
    "document_type__QUOTE": "Devis",
    "document_type__RETURN": "Retour",
    "document_type__CONTRACT": "Contrat",
    "document_type__DEBIT_MEMO_REQUEST": "Demande de note de débit",
    "document_type__CREDIT_MEMO_REQUEST": "Demande d'avoir",
    "saved_views__all_views": "Toutes les vues",
    "saved_views__my_views": "Mes vues",
    "saved_views__shared_views": "Vues partagées",
    "saved_views__delete": "Supprimer",
    "saved_views__delete_confirmation_title": "Supprimer la vue de filtres",
    "saved_views__delete_confirmation_description": "Voulez-vous vraiment supprimer cette vue de filtres ? Cette action est irréversible.",
    "save_view_dialog__title": "Enregistrer la vue",
    "save_view_dialog__name_placeholder": "Saisir un nom",
    "save_view_dialog__save_button": "Enregistrer",
    "saved_views__presets": "Préréglages",
    "saved_views__save_as_new": "Enregistrer comme nouvelle vue…",
    "saved_views__save_error": "La vue n'a pas pu être enregistrée",
    "saved_views__delete_error": "La vue n'a pas pu être supprimée",
    "save_view_dialog__share_with_team": "Partager avec mon équipe",
    "saved_views__more_views": "Plus de vues",
    "saved_views__view": "Vue",
    "saved_views__save_changes": "Enregistrer les modifications",
    "saved_views__revert": "Rétablir",
    "relative_timestamp__just_now": "à l’instant"
}
